if (!customElements.get('rz-popup-modal')) {
  customElements.define(
    'rz-popup-modal',
    class RzPopupModal extends BasicModal {
      get contentElement() {
        return this.querySelector('[data-rz-popup-content]');
      }

      get spinner() {
        return this.querySelector('.loading__spinner');
      }

      prepareToShow() {
        super.prepareToShow();
        this.loadContent();
      }

      loadContent() {
        // Без data-url съдържанието е рендирано инлайн — няма какво да се дърпа.
        if (!this.dataset.url || this._loaded || this._loading) return;

        this._loading = true;
        this.spinner && this.spinner.classList.remove('hidden');

        fetch(`${this.dataset.url.split('?')[0]}?section_id=rz-popup-content`)
          .then((response) => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.text();
          })
          .then((responseText) => {
            const source = new DOMParser().parseFromString(responseText, 'text/html').querySelector('#RzPopupContent');

            if (!source) throw new Error('липсва #RzPopupContent в отговора');

            this.contentElement.innerHTML = source.innerHTML;
            this._loaded = true;

            // Съдържанието се появява след handleAfterShow, затова фокусът
            // се трапва наново върху вече попълнения панел.
            if (this.open) {
              FoxTheme.a11y.trapFocus(this, this.focusElement);
            }
          })
          .catch((error) => {
            console.error('RZ Pop Up:', error);
          })
          .finally(() => {
            this._loading = false;
            this.spinner && this.spinner.classList.add('hidden');
          });
      }
    }
  );
}
